import { lang } from '../../common/page';
import { LOCALES } from './support-constants';

/**
 * Date formatting
 */
export const getFormattedDate = (paramDate, clientTimezone = null) => {
  const dateFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timezone: clientTimezone,
  };
  const localeLang = LOCALES.get(lang);

  return new Date(paramDate).toLocaleDateString(localeLang, dateFormatOptions).replaceAll('/', '-').replaceAll(',', '');
};

const getCalendarDayKey = (date, timeZone) => new Intl.DateTimeFormat('en-CA', {
  timeZone,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
}).format(date);

const getDaysBetweenCalendarDays = (fromKey, toKey) => {
  const dayMs = 24 * 60 * 60 * 1000;
  return Math.round(
    (new Date(`${toKey}T12:00:00`).getTime() - new Date(`${fromKey}T12:00:00`).getTime()) / dayMs
  );
};

export const getFormattedDateForStatus = (
  paramDate,
  clientTimezone = null
) => {
  const date = new Date(paramDate);

  const parts = new Intl.DateTimeFormat('en-IN', {
    timeZone: clientTimezone,
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).formatToParts(date);

  const get = (type) => parts.find((p) => p.type === type)?.value;
  const time = `${get('hour')}:${get('minute')} ${get('dayPeriod').toUpperCase()}`;

  const daysAgo = getDaysBetweenCalendarDays(
    getCalendarDayKey(date, clientTimezone),
    getCalendarDayKey(new Date(), clientTimezone)
  );

  if (daysAgo === 0) return `Today ${time}`;
  if (daysAgo === 1) return `Yesterday ${time}`;

  return `${get('month')} ${get('day')}, ${get('year')} ${time}`;
};
